/** Shared namespace guard, including nested encoding and URL dot-segment normalisation. */
export function blockedReturnPath(path: string): boolean {
  for (let depth = 0; depth < 8; depth++) {
    try {
      const pathname = new URL(path, "https://app.invalid").pathname;
      if (/^\/(login|register|api)(\/|$)/i.test(pathname)) return true;
      const decoded = decodeURIComponent(path);
      if (decoded === path) return false;
      path = decoded;
    } catch {
      return true;
    }
  }
  return true;
}
